/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundMutationResponse,
  PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundPathParams,
  PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundQueryParams,
  PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund400,
  PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund401,
  PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund500,
} from "../../types/pecegePayCreditCardController/PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { patchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund } from "../../clients/pecegePayCreditCardController/patchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund.ts";

export const patchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundMutationKey =
  () =>
    [
      { url: "/api/v1/pecegepay/creditcard/:courseFinPersonPaymentId/refund" },
    ] as const;

export type PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundMutationKey =
  ReturnType<
    typeof patchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundMutationKey
  >;

export function patchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey =
    patchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundMutationKey();
  return mutationOptions<
    PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund400
      | PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund401
      | PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund500
    >,
    {
      courseFinPersonPaymentId: PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundPathParams["courseFinPersonPaymentId"];
      params?: PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundQueryParams;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ courseFinPersonPaymentId, params }) => {
      return patchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund(
        courseFinPersonPaymentId,
        params,
        config,
      );
    },
  });
}

/**
 * @description Registra um pedido de estorno de pagamento com cartão de crédito.
 * @summary Registrar estorno de cartão de crédito
 * {@link /api/v1/pecegepay/creditcard/:courseFinPersonPaymentId/refund}
 */
export function usePatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundMutationResponse,
      ResponseErrorConfig<
        | PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund400
        | PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund401
        | PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund500
      >,
      {
        courseFinPersonPaymentId: PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundPathParams["courseFinPersonPaymentId"];
        params?: PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundQueryParams;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundMutationKey();

  const baseOptions =
    patchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundMutationOptions(
      config,
    ) as UseMutationOptions<
      PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundMutationResponse,
      ResponseErrorConfig<
        | PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund400
        | PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund401
        | PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund500
      >,
      {
        courseFinPersonPaymentId: PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundPathParams["courseFinPersonPaymentId"];
        params?: PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundQueryParams;
      },
      TContext
    >;

  return useMutation<
    PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund400
      | PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund401
      | PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund500
    >,
    {
      courseFinPersonPaymentId: PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundPathParams["courseFinPersonPaymentId"];
      params?: PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundQueryParams;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund400
      | PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund401
      | PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund500
    >,
    {
      courseFinPersonPaymentId: PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundPathParams["courseFinPersonPaymentId"];
      params?: PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundQueryParams;
    },
    TContext
  >;
}
